var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"home"},[_c('vue-title',{attrs:{"title":"WOLF | Home"}}),_c('Header'),_c('div',{staticClass:"container"},[_c('h3',{class:{
        light: !_vm.isDarkMode,
        dark: _vm.isDarkMode
      }},[_vm._v(" Home ")])])],1)}
var staticRenderFns = []

export { render, staticRenderFns }